import "./contact-form.css";
import { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import { useForm } from '@formspree/react';

const EMPTY = { name: "", companyName: "", email: "", budget: "", details: "" };

function ContactForm({ color, phoneNumber }) {
  const [state, handleSubmit] = useForm("meoqwbjv");
  const [submitted, setSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [values, setValues] = useState(EMPTY);
  const formRef = useRef(null);

  useEffect(() => {
    if (state.succeeded) {
      setShowModal(true);
      setValues(EMPTY);
      setSubmitted(false);
    }
  }, [state.succeeded]);

  const handleChange = (e) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmit = (e) => {
    setSubmitted(true);
    if (!values.email || !values.details) {
      e.preventDefault();
      return;
    }
    handleSubmit(e);
  };

  const closeModal = () => setShowModal(false);

  const colorClass = color === "dark" ? "contact-form-dark" : color === "light" ? "contact-form-light" : "";

  return (
    <div className={`contact-form ${colorClass}`} ref={formRef}>
      <h1 className={`${phoneNumber ? "contact-form-heading" : ""}`}>
        <span className="bold">Let&apos;s</span> work together
      </h1>
      {phoneNumber ? (
        <a className="contact-form-number" href="tel:+995514710077">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M15.375 0C15.4594 0 15.5406 0 15.625 0C15.8 0.0782077 15.925 0.208554 16 0.391039C16 0.488798 16 0.586558 16 0.684318C15.925 0.928717 15.9125 1.18289 15.8781 1.43381C15.6719 2.8611 15.4688 4.28839 15.2656 5.71568C15.0625 7.13646 14.8594 8.56049 14.6562 9.98126C14.4906 11.1348 14.325 12.2884 14.1625 13.442C14.1469 13.5462 14.1125 13.644 14.0437 13.7189C13.8656 13.9242 13.6531 13.9275 13.4156 13.8428C11.1594 13.0346 8.9 12.233 6.64375 11.4248C6.60938 11.4118 6.55937 11.4151 6.5375 11.3564C8.76562 8.55723 10.9969 5.75153 13.2437 2.93279C13.1625 2.93279 13.1406 2.97515 13.1094 3.00122C10.2844 5.52016 7.45625 8.0391 4.63438 10.5613C4.54375 10.6428 4.46875 10.6558 4.35625 10.6167C3.075 10.154 1.79062 9.6945 0.50625 9.24481C0.28125 9.1666 0.1 9.05906 0 8.83096C0 8.74297 0 8.65825 0 8.57026C0.06875 8.40081 0.178125 8.27373 0.3375 8.18574C3.0625 6.70631 5.78437 5.22363 8.50937 3.74094C10.7969 2.49613 13.0875 1.24807 15.375 0Z"
              fill="black"
            />
            <path
              d="M6.28118 15.9997C5.91243 15.8564 5.83743 15.7423 5.83743 15.3219C5.83743 14.3672 5.83743 13.4091 5.83743 12.4543C5.83743 12.3891 5.82493 12.324 5.85618 12.249C6.1593 12.3566 6.46243 12.4674 6.76868 12.5749C7.31868 12.7704 7.86868 12.9692 8.42181 13.1614C8.52181 13.1973 8.53743 13.2266 8.46868 13.3211C7.89993 14.1228 7.33118 14.9276 6.76868 15.7358C6.67493 15.8694 6.54993 15.9443 6.40618 15.9997C6.36556 15.9997 6.32181 15.9997 6.28118 15.9997Z"
              fill="black"
            />
          </svg>
          &nbsp;&nbsp;&nbsp;
          <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
            <path d="M0 2.42534C0.327921 1.08495 1.37505 0.498627 2.51089 0.0273338C2.66931 -0.0381679 2.94495 0.0257362 3.09545 0.132776C3.35208 0.313305 3.59921 0.544957 3.7703 0.810159C4.35485 1.7176 4.91881 2.63782 5.45901 3.57242C5.73465 4.0501 5.66178 4.53737 5.31327 4.97192C5.30535 4.9815 5.29901 4.99109 5.29267 5.00067C4.58931 5.93527 4.43089 6.2468 5.29109 7.4482C6.27644 8.82374 7.47564 9.99318 8.86653 10.9501C9.64911 11.4885 10.0547 11.4949 10.785 10.891C11.425 10.3606 12.0586 10.2983 12.7366 10.7297C13.6349 11.3016 14.5267 11.8847 15.3996 12.495C15.642 12.6644 15.8051 12.9503 16.0032 13.1836C16.0032 13.2555 16.0032 13.3274 16.0032 13.3993C15.9034 13.5431 15.7988 13.682 15.7069 13.8306C15.4646 14.2252 15.2554 14.6438 14.983 15.0145C14.4428 15.7525 13.703 16.1104 12.7921 15.9714C12.3422 15.9027 11.8891 15.7717 11.4725 15.5864C8.72396 14.3706 6.33663 12.6324 4.33426 10.3894C2.41743 8.24381 0.736634 5.93687 0 3.07077C0 2.85509 0 2.64101 0 2.42534Z" fill="#050320" />
          </svg>
          &nbsp;&nbsp;&nbsp;995514710077
        </a>
      ) : null}

      <Form className="contact-form-container" onSubmit={onSubmit}>
        <Form.Group className="form-inputs">
          <Form.Control
            id="name"
            type="text"
            name="name"
            placeholder="Your Name"
            value={values.name}
            onChange={handleChange}
          />
          <Form.Control
            id="companyName"
            type="text"
            name="companyName"
            placeholder="Company Name"
            value={values.companyName}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group className="form-inputs">
          <Form.Control
            id="email"
            type="email"
            name="email"
            placeholder="Email"
            value={values.email}
            onChange={handleChange}
            className={submitted && !values.email ? "input-error" : ""}
          />
          <Form.Control
            id="budget"
            type="text"
            name="budget"
            placeholder="Budget"
            value={values.budget}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group className="form-textarea">
          <Form.Control
            id="details"
            as="textarea"
            name="details"
            placeholder="Project Details"
            value={values.details}
            onChange={handleChange}
            className={submitted && !values.details ? "input-error" : ""}
          />
        </Form.Group>

        <button className="contact-form-submit" type="submit" disabled={state.submitting}>
          Send Request
        </button>

        {showModal && (
          <>
            <div className="cf-success-overlay">
              <div className="cf-success-content">
                <svg xmlns="http://www.w3.org/2000/svg" width={84} height={84} viewBox="12 3 84 84" fill="none">
                  <g filter="url(#filter0_ddd_1541_962)">
                    <circle cx={54} cy={45} r={42} fill="white" />
                    <path d="M65.0391 35.75C65.3635 35.75 65.6733 35.8846 65.8994 36.1201C66.1249 36.3552 66.2499 36.6719 66.25 37C66.25 37.3283 66.125 37.6457 65.8994 37.8809L50.54 53.8799C50.4282 53.9966 50.2941 54.0896 50.1465 54.1533C49.9991 54.2169 49.8408 54.2499 49.6807 54.25C49.5203 54.25 49.3614 54.217 49.2139 54.1533C49.0663 54.0896 48.9322 53.9966 48.8203 53.8799L42.1006 46.8809C41.8748 46.6457 41.75 46.3284 41.75 46C41.75 45.6716 41.8749 45.3543 42.1006 45.1191C42.3267 44.8836 42.6365 44.749 42.9609 44.749C43.2852 44.7491 43.5943 44.8837 43.8203 45.1191L49.6797 51.2236L64.1797 36.1201C64.4057 35.8847 64.7148 35.7501 65.0391 35.75Z" fill="#14A800" stroke="#14A800" strokeWidth="0.5" />
                  </g>
                  <defs>
                    <filter id="filter0_ddd_1541_962" x={0} y={0} width={108} height={120} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                      <feFlood floodOpacity={0} result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy={2} />
                      <feGaussianBlur stdDeviation="2.5" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.03 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1541_962" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy={9} />
                      <feGaussianBlur stdDeviation="4.5" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.03 0" />
                      <feBlend mode="normal" in2="effect1_dropShadow_1541_962" result="effect2_dropShadow_1541_962" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy={21} />
                      <feGaussianBlur stdDeviation={6} />
                      <feColorMatrix type="matrix" values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.02 0" />
                      <feBlend mode="normal" in2="effect2_dropShadow_1541_962" result="effect3_dropShadow_1541_962" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_1541_962" result="shape" />
                    </filter>
                  </defs>
                </svg>
                <h2 className="cf-success-title">We have Received your email</h2>
                <p className="cf-success-body">Our super team will try to get back to you in 48 hours<br />with the information you need!</p>
                <button className="cf-success-close cf-success-close--inside" onClick={closeModal}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
                    <path d="M0.0130881 15.0596L15.0596 0.0139774L16 0.954332L0.953495 16L0.0130881 15.0596Z" fill="#0E0E23" />
                    <path d="M0.940407 0L15.9869 15.0457L15.0465 15.986L0 0.940354L0.940407 0Z" fill="#0E0E23" />
                  </svg>
                  &nbsp;
                  &nbsp;
                  Close
                </button>
              </div>
            </div>
          </>
        )}
      </Form>
      {showModal &&
        <button className="cf-success-close cf-success-close--outside" onClick={closeModal}>
          <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
            <path d="M0.0130881 15.0596L15.0596 0.0139774L16 0.954332L0.953495 16L0.0130881 15.0596Z" fill="#0E0E23" />
            <path d="M0.940407 0L15.9869 15.0457L15.0465 15.986L0 0.940354L0.940407 0Z" fill="#0E0E23" />
          </svg>
          &nbsp;
          &nbsp;
          Close
        </button>
      }
    </div>
  );
}

export default ContactForm;
